import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-registration-confirm-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        ยืนยันการลงทะเบียน
      </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="confirmation-message">
        <div class="warning-icon">
          <i class="bi bi-info-circle-fill"></i>
        </div>
        <div class="message-content">
          <h5>ต้องการยืนยันการลงทะเบียนหรือไม่</h5>
          <p class="warning-text">
            กรุณาตรวจสอบข้อมูลการลงทะเบียนให้ถูกต้องก่อนยืนยัน 
            เนื่องจากจะไม่สามารถแก้ไขข้อมูลทั้งหมดได้ด้วยตนเองหลังจากยืนยันการลงทะเบียนแล้ว
          </p>
          <div class="info-box">
            <i class="bi bi-lightbulb me-2"></i>
            <span>หากต้องการแก้ไขข้อมูลหลังจากยืนยันแล้ว จะต้องติดต่อเจ้าหน้าที่เพื่อดำเนินการ</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-cancel" (click)="activeModal.dismiss()">
        <i class="bi bi-x-circle me-2"></i>
        ยกเลิก
      </button>
      <button type="button" class="btn btn-confirm" (click)="confirm()">
        <i class="bi bi-check-circle me-2"></i>
        ยืนยันการลงทะเบียน
      </button>
    </div>
  `,
  styles: [`
    .modal-header {
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
      color: white;
      border-bottom: none;
      padding: 1.5rem 2rem;
      border-radius: 0;

      .modal-title {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0;
        display: flex;
        align-items: center;

        i {
          font-size: 1.75rem;
        }
      }

      .btn-close {
        filter: brightness(0) invert(1);
        opacity: 0.8;

        &:hover {
          opacity: 1;
        }
      }
    }

    .modal-body {
      padding: 2rem;
    }

    .confirmation-message {
      display: flex;
      gap: 1.5rem;
      align-items: flex-start;

      .warning-icon {
        flex-shrink: 0;
        width: 64px;
        height: 64px;
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);

        i {
          font-size: 2rem;
          color: #f59e0b;
        }
      }

      .message-content {
        flex: 1;

        h5 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 1rem 0;
        }

        .warning-text {
          font-size: 1rem;
          color: #4b5563;
          line-height: 1.6;
          margin: 0 0 1.5rem 0;
        }

        .info-box {
          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
          border-left: 4px solid #3b82f6;
          padding: 1rem 1.25rem;
          border-radius: 8px;
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;

          i {
            font-size: 1.25rem;
            color: #3b82f6;
            flex-shrink: 0;
            margin-top: 2px;
          }

          span {
            font-size: 0.9rem;
            color: #1e40af;
            line-height: 1.5;
          }
        }
      }
    }

    .modal-footer {
      padding: 1.5rem 2rem;
      border-top: 2px solid #f3f4f6;
      display: flex;
      gap: 1rem;
      justify-content: flex-end;

      .btn {
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
        font-weight: 600;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        i {
          font-size: 1.25rem;
        }

        &.btn-cancel {
          background: #f3f4f6;
          color: #6b7280;

          &:hover {
            background: #e5e7eb;
            color: #374151;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
        }

        &.btn-confirm {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);

          &:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
          }
        }

        &:active {
          transform: translateY(0);
        }
      }
    }

    @media (max-width: 768px) {
      .confirmation-message {
        flex-direction: column;
        align-items: center;
        text-align: center;

        .warning-icon {
          width: 56px;
          height: 56px;

          i {
            font-size: 1.75rem;
          }
        }

        .message-content {
          .info-box {
            text-align: left;
          }
        }
      }

      .modal-footer {
        flex-direction: column;

        .btn {
          width: 100%;
          justify-content: center;
        }
      }
    }
  `]
})
export class RegistrationConfirmModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  confirm(): void {
    this.activeModal.close('confirm');
  }
}
